// extracted by mini-css-extract-plugin
export default {"container":"PvzSaWYmHXjQLu2efiFJ2A==","content":"BWQHgEnyFVyBW+TlbmMsSQ==","lottieContainer":"GwJ1JTrqYkJBKuKIaMkl3Q==","lottie":"LHj9Jcatb8eAVZ3V+dnb0g=="};